module.exports = __webpack_public_path__ + "static/media/addToConf.c7f45bb0.svg";